"use strict";
export const TeamMock = (mock) => {
  mock.onGet("/v7/my_team").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "role": "role_bb2dc05f98dd4d0980b56d6fced737fa",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456aa",
            "account": "136720214790089",
            "name": "\u738B\u6668",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_cf94117f16cd4bf1976d7c0851c7c590",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u7ECF\u7406"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "896084owmx",
            "account": "136720214790088",
            "name": "\u6D69\u7136",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_f02bd70481664827af9f81efb98c5cfb",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": "15122077647",
            "lock": false,
            "role_name": "\u5458\u5DE5"
          },
          {
            "role": "role_bb2dc05f98dd4d0980b56d6fced737fa",
            "department": [
              {
                "model": "department.model",
                "name": "22wew5e4ew4e",
                "id": "department_edff6a1c98534519a74b706967f05d09"
              }
            ],
            "model": "sub_account",
            "original_password": "480950gznn",
            "account": "136720214790079",
            "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
            "shop_count": 9,
            "vd_count": 1,
            "comment": "\u5168\u8BBE\u590712\uFF1A00-12\uFF1A30",
            "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
            "device_limit_type": "every_device_limit",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": "18712701715",
            "lock": false,
            "role_name": "\u7ECF\u7406"
          },
          {
            "role": "role_bb2dc05f98dd4d0980b56d6fced737fa",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790078",
            "name": "\u5458\u5DE5783216520321650531525621563152152153621562326152",
            "shop_count": 0,
            "vd_count": 0,
            "comment": "\u6BCF\u6B21\u767B\u5F55\u65B0\u8BBE\u5907\u9700\u9A8C\u8BC1\u4E0D\u9650\u65F6\u95F4",
            "guid": "user_fa8d381de4864dba87c903808170bb09",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u7ECF\u7406"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790077",
            "name": "\u5458\u5DE5772321321322312115605615030330020320323220312320",
            "shop_count": 0,
            "vd_count": 0,
            "comment": "\u9996\u6B21\u767B\u5F55\u9700\u6388\u6743\uFF0C\u540E\u7EED\u4E0D\u9650 \u4E0D\u9650\u65F6\u95F4",
            "guid": "user_4272f0df416146ff9f255067afd8d03a",
            "device_limit_type": "every_device_limit",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u5458\u5DE5"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790076",
            "name": "\u5458\u5DE576",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_44d6240560e84a9784a171d8b1bd58a9",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u5458\u5DE5"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790075",
            "name": "\u5458\u5DE575",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_aa16dd48251a4176bd9b819d4b36dcbf",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u5458\u5DE5"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "22wew5e4ew4e",
                "id": "department_edff6a1c98534519a74b706967f05d09"
              },
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790073",
            "name": "\u5458\u5DE573",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_62c070277d1d4275ac81e904591f3c5d",
            "device_limit_type": "every_device_limit",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u5458\u5DE5"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "\u6D4B\u8BD5\u90E8\u95E83",
                "id": "department_8d9f65a9c579402989c811bcc8915d0b"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790071",
            "name": "\u5458\u5DE571",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_76289cedef12419baf324b421e36ca66",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u5458\u5DE5"
          },
          {
            "role": "role_173187653972492d8980ce62c449b861",
            "department": [
              {
                "model": "department.model",
                "name": "13672021479\u56E2\u961F",
                "id": "org_oe2c8f1fae2e542e08ccfb13b1e3d848f"
              }
            ],
            "model": "sub_account",
            "original_password": "123456a",
            "account": "136720214790070",
            "name": "\u5458\u5DE570",
            "shop_count": 0,
            "vd_count": 0,
            "comment": null,
            "guid": "user_c408272d46d141acb35c228223781828",
            "device_limit_type": "all_device_permanent",
            "login_limit_time": "\u4E0D\u9650",
            "nickname": null,
            "phone": null,
            "lock": false,
            "role_name": "\u5458\u5DE5"
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 57,
        "size": 10
      }
    };
    return [200, response];
  });
};
